import styled from 'styled-components'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { SpecialRequestGridCard } from '@/features/shop/components/SpecialRequestGridCard'
import { Column, Box } from '@shipt/design-system-layouts'
import { Body, Headline } from '@shipt/design-system-typography'
import { objectStorageUrl } from '@/features/shared/utils/objectStorageUrl'
import { useUser } from '@/features/account/services/User/hooks'

type Props = { query: string; hideSpecialRequest?: boolean }

export const SearchEmptyState = ({ query, hideSpecialRequest = false }: Props) => {
  const user = useUser()
  return (
    <FullWidthBox>
      <Column align="center" margin={{ base: ['xl', 0, 'xl', 0], md: ['3xl', 0, '3xl', 0] }}>
        <EmptyStateImageContainer>
          <Image fill sizes="160px" src={objectStorageUrl('error-search.png')} alt="" />
        </EmptyStateImageContainer>
        <Column spacing="sm">
          <Headline align="center" as="h2">
            {`Sorry, no results were found for\n"${query}"`}
          </Headline>
          <Body variant="secondary" align="center">
            Check the spelling or try using more general keywords.
          </Body>
        </Column>
        {!hideSpecialRequest && !!user && (
          <Box marginTop={{ base: 'xl', md: '3xl' }}>
            <SpecialRequestGridCard />
          </Box>
        )}
      </Column>
    </FullWidthBox>
  )
}

const FullWidthBox = styled(Box)`
  width: 100%;
`

const EmptyStateImageContainer = styled.div`
  height: 10rem;
  width: 10rem;
  position: relative;
  margin: 0 auto;
`
